import React, { memo, useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import PageContainer from '../../Components/PageContainer'
import Fade from 'react-reveal/Fade'
import { auth } from '../../firebase'
import { useNavigate } from 'react-router'
import cloudFunctions from '../../Helpers/cloudFunctions'
import { toast } from 'react-toastify'
import TagsCollection from '../../Components/PopularTags'
import Picker from 'emoji-picker-react';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import ReactTooltip from 'react-tooltip';
import { UserContext } from '../../Helpers/user.context'
import Switch from "react-switch";

export default function Create() {
    const [pollTitle, setPollTitle] = useState("")
    const [pollType, setPollType] = useState("normal")
    const [options, setOptions] = useState(["", ""])
    const [selectedSliderEmojiOne, setSelectedSliderEmojiOne] = useState("")
    const [selectedSliderEmojiTwo, setSelectedSliderEmojiTwo] = useState("")
    const [demoSliderValue, setDemoSliderValue] = useState(50)
    const [tags, setTags] = useState(new Array())
    const [addTagInput, setAddTagInput] = useState("")
    const [mediaLink, setMediaLink] = useState("")
    const [mediaType, setMediaType] = useState("")
    const [expireDate, setExpireDate] = useState(null)
    const [description, setDescription] = useState("")
    const [voterCountLimitActive, setVoterCountLimitActive] = useState(false)
    const [voterCountLimit, setVoterCountLimit] = useState("")
    const [cta, setCTA] = useState("")
    const [pollAnalytics, setPollAnalytics] = useState(false)
    const [privatePoll, setPrivatePoll] = useState(false)
    const userData = useContext(UserContext)
    const navigate = useNavigate()
    const onSubmit = () => {
        const continuePost = () => {
            const loader = toast.loading("Posting your poll...")
            const newExpireDate = expireDate ? expireDate : (userData.isPro ? false : new Date().setDate(new Date().getDate() + 7))
            cloudFunctions.postPoll({
                title: pollTitle,
                type: pollType,
                options: options,
                tags: tags,
                mediaLink: mediaLink,
                mediaType: mediaType,
                selectedSliderEmojiOne: pollType === "slider" ? (selectedSliderEmojiOne || "☹️") : null,
                selectedSliderEmojiTwo: pollType === "slider" ? (selectedSliderEmojiTwo || "😍") : null,
                expiryDate: newExpireDate,
                description: description,
                voterCountLimit: voterCountLimitActive ? parseInt(voterCountLimit) : false,
                pollAnalytics: pollAnalytics,
                cta: cta,
                private: privatePoll
            })
                .then((res) => {
                    toast.update(loader, {
                        render: "Your poll is live!",
                        icon: "✔️"
                    })
                    const response = res.data
                    if (response.error) {
                        toast.update(loader, {
                            render: response.msg,
                            icon: "❌"
                        })
                    } else {
                        toast.update(loader, {
                            render: "Your poll is live!",
                            icon: "✔️"
                        })
                        if (privatePoll) {
                            navigate(`/pvt/poll/${response.data}`)
                        } else {
                            navigate(`/poll/${response.data}`)
                        }
                    }
                })
                .catch((err) => {
                    console.log(err)
                    toast.update(loader, {
                        render: "Something went wrong",
                        icon: "❌"
                    })
                })
                .finally(() => {
                    setTimeout(() => {
                        toast.dismiss(loader)
                    }, 2000)
                })
        }
        if (pollTitle && pollType) {
            if (pollType !== "slider") {
                for (let i = 0; i < options.length; i++) {
                    const newSearchArray = [...options]
                    newSearchArray.splice(i, 1)
                    if (newSearchArray.includes(options[i])) {
                        toast.error("Options can not be the same")
                        break
                    } else {
                        if (i + 1 === options.length) {
                            continuePost()
                        }
                    }
                }
            } else {
                continuePost()
            }
        } else {
            toast.error("Some fields are empty")
        }
    }
    const addTag = () => {
        if (!(tags.length > 4 || !addTagInput)) {
            const newTags = [...tags]
            if (addTagInput.length > 15) {
                return toast.error("Tag too long!")
            }
            newTags.push(addTagInput)
            setTags(newTags)
            setAddTagInput("")
        } else {
            if (!addTagInput.length) {
                toast.error("Add some content")
            } else {
                toast.error("Tag limit reached")
            }
        }
    }
    useEffect(() => {
        if (!voterCountLimitActive) {
            setVoterCountLimit("")
        }
    }, [voterCountLimitActive])
    const EmojiInput = ({ selected, setSelected }) => {
        const [active, setActive] = useState(false)
        return (
            <div style={{ position: "relative" }}>
                <div onClick={() => setActive(!active)} style={{ width: 50, height: 50, border: "1px solid rgba(0,0,0,.1)", padding: 0, borderRadius: 10, cursor: "pointer" }} className="flex aic jcc">
                    {selected
                        ? <p style={{ margin: 0, fontSize: 24 }}>{selected.emoji}</p>
                        : <svg style={{ opacity: .5 }} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" /></svg>
                    }
                </div>
                <div style={{ position: "absolute", zIndex: 5000 }}>
                    {active
                        ? <Picker onEmojiClick={(_, em) => setSelected(em)} />
                        : null
                    }
                </div>
            </div>
        )
    }
    const PollTypeSelect = ({ selectedProp, type, val, set }) => {
        const [selected, setSelected] = useState(selectedProp)
        useEffect(() => {
            setSelected(selectedProp)
        }, [selectedProp])
        return (
            <div style={{ flex: 1 }} className={`pollTypeSelector flex aic jcsb bb ${selected ? "pollTypeSelectorSelected" : ""}`} onClick={() => set(val)}>
                <p>
                    {type}
                </p>
                {selected
                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 0C5.38346 0 0 5.38346 0 12C0 18.6165 5.38346 24 12 24C18.6165 24 24 18.6165 24 12C24 5.38346 18.6165 0 12 0ZM18.7068 8.84211L11.0376 16.4511C10.5865 16.9023 9.86466 16.9323 9.38346 16.4812L5.32331 12.782C4.84211 12.3308 4.81203 11.5789 5.23308 11.0977C5.68421 10.6165 6.43609 10.5865 6.91729 11.0376L10.1353 13.985L16.9925 7.12782C17.4737 6.64662 18.2256 6.64662 18.7068 7.12782C19.188 7.60902 19.188 8.3609 18.7068 8.84211Z" fill="#0074D9" />
                    </svg>

                    : null
                }
            </div>
        )
    }
    const CreateAspectTitle = ({ children, tip, title }) => {
        return (
            <>
                <ReactTooltip html place="right" effect="solid" />
                <div className='flex aic' style={{ marginBottom: 20, gap: 10 }}>
                    <p style={{ margin: 0, fontWeight: "bold", color: "#212121", fontSize: 18, width: "fit-conent" }}>{children}</p>
                    <svg data-tip={
                        "<strong>" + title + "</strong><br/>" + tip
                    } xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#212121"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>
                </div>
            </>
        )
    }
    const InputHeader = ({ children }) => {
        return (
            <p style={{ color: "#212121", fontWeight: "bold", margin: 0, marginBottom: 15, fontSize: 18 }}>{children}</p>
        )
    }
    const onExpireChange = (e) => {
        const today = new Date()
        if (new Date(e.target.value).getTime() < Date.now()) {
            toast.error("Must be a future date")
        } else if (new Date(e.target.value).getTime() > new Date(today.setDate(today.getDate() + 7)).getTime() && !userData.isPro) {
            toast.error("Cannot last for over 7 days")
        }
    }
    return (
        <>
            <PageContainer>
                <div style={{ padding: "0 30px" }} className="pgePadd">
                    <h1 style={{ marginTop: 40 }}>Create a poll</h1>
                    <div style={{ background: "#fff", padding: 30, borderRadius: 20 }}>
                        <div style={{ gap: 20, marginTop: !auth.currentUser ? 30 : 0, position: "relative" }}>
                            {!auth.currentUser
                                ? <>
                                    <div className='flex aic jcsb' style={{ gap: 20 }}>
                                        <button className='b5' onClick={() => navigate("/signup")}>Sign Up</button>
                                        <p style={{ fontWeight: 700, opacity: .5, fontSize: 17 }}>or</p>
                                        <button className='b6' onClick={() => navigate("/login")}>Login</button>
                                    </div>
                                    <div style={{ marginTop: 30, gap: 20 }} className="flex aic jcsb">
                                        <div style={{ flex: 1, height: 3, background: "rgba(0,0,0,.1)" }} />
                                        <p style={{ fontWeight: 600, fontSize: 15, opacity: .6, margin: 0 }}>Authenticate to create polls</p>
                                        <div style={{ flex: 1, height: 3, background: "rgba(0,0,0,.1)" }} />
                                    </div>
                                </>
                                : null
                            }
                        </div>
                        <div className={!auth.currentUser ? "disabled" : ""} style={{ marginTop: 0, width: "100%" }}>
                            <CreateAspectTitle title={"Poll Type:"} tip={
                                "Normal : Normal poll<br/> Slider : Slider range for the polls<br/> Rank: Sort your polls answers by rank"
                            }>Poll type</CreateAspectTitle>
                            <div className='flex aic flexboxCreateSegment' style={{ gap: 20, flexWrap: "wrap", width: "100%" }}>
                                <PollTypeSelect type="Normal" val={"normal"} selectedProp={pollType === "normal"} set={setPollType} />
                                <PollTypeSelect type="Ranked" val={"rank"} selectedProp={pollType === "rank"} set={setPollType} />
                                <PollTypeSelect type="Slider" val={"slider"} selectedProp={pollType === "slider"} set={setPollType} />
                            </div>
                            <div style={{ margin: "40px 0" }}>
                                <InputHeader>Poll Title</InputHeader>
                                <input type="text" className='input' placeholder='Poll Title' style={{ width: "100%" }} value={pollTitle} onChange={(e) => setPollTitle(e.target.value)} />
                            </div>
                        </div>
                        <div className={!auth.currentUser ? "disabled" : ""} style={{ marginTop: 30 }}>
                            {pollType
                                ? <>{pollType === "normal" || pollType === "rank"
                                    ? <div>
                                        <InputHeader>Poll Options</InputHeader>
                                        <div className='flex fdc' style={{ gap: 15 }}>
                                            {options.map((option, idx) => (
                                                <Fade right duration={400} key={idx}>
                                                    <div className='flex optionContainer' id={"optionContainer" + idx} style={{ gap: 10 }}>
                                                        <input id={"optionInput" + idx} style={{ flex: 1 }} className='input' type="text" placeholder={"Option " + (idx + 1)} value={options[idx]} onChange={(e) => {
                                                            const newOptions = [...options]
                                                            newOptions[idx] = e.target.value
                                                            setOptions(newOptions)
                                                        }} />
                                                        {idx !== 0 && idx !== 1
                                                            ? <button onClick={() => {
                                                                const newOptions = [...options]
                                                                newOptions.splice(idx, 1)
                                                                setOptions(newOptions)
                                                            }} style={{ width: 60, height: 65, background: "#f1f1f1", borderRadius: 10, backgroundColor: "rgb(255, 70, 70)", cursor: "pointer", border: "none" }} className="flex aic jcc">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="25px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" /></svg>
                                                            </button>
                                                            : null
                                                        }
                                                    </div>
                                                </Fade>
                                            ))}
                                        </div>
                                        {options.length < 10 || userData.isPro
                                            ? <button className={`b1`} onClick={() => setOptions([...options, ""])}>
                                                <p style={{ color: "#0074D9", fontWeight: 700, fontSize: 15 }}>+ Add Option</p>
                                            </button>
                                            : null
                                        }
                                    </div>
                                    : <div style={{ boxShadow: "0px 0px 10px rgba(0,0,0,.1)", width: "100%", borderRadius: 20, padding: 30, zIndex: 5000000000 }} className="bb">
                                        <h2 style={{ margin: 0 }}>Your slider poll</h2>
                                        <div style={{ width: "100%", height: 3, background: "rgba(0,0,0,.1)", margin: "20px 0" }} />
                                        <div className='flex jcsb aic' style={{ flex: 1, zIndex: 5000000000 }}>
                                            <EmojiInput selected={selectedSliderEmojiOne} setSelected={setSelectedSliderEmojiOne} />
                                            <div style={{ width: "100%", padding: "0 20px" }}>
                                                <Slider
                                                    min={0}
                                                    max={100}
                                                    value={demoSliderValue}
                                                    onChange={value => setDemoSliderValue(value)}
                                                    className="slider"
                                                    tooltip={false}
                                                />
                                            </div>
                                            <EmojiInput selected={selectedSliderEmojiTwo} setSelected={setSelectedSliderEmojiTwo} />
                                        </div>
                                    </div>
                                }</>
                                : null
                            }
                            <div className='flex fdc flexboxCreateSegment' style={{ gap: 20, paddingTop: 20, marginTop: 15, borderTop: "2px solid rgba(0,0,0,.1)" }}>
                                <div>
                                    <CreateAspectTitle title={"Embed Type:"} tip={
                                        `Image : Upload any image on the poll <br/>
                                        Youtube : Add any youtube video in poll <br/>
                                    Spotify : Add any spotify podcast/song in poll <br/>
                                    Soundcloud: Add any content from soundcloud in your poll`
                                    }>Embed Type</CreateAspectTitle>
                                    <div className='flex aic flexboxCreateSegment' style={{ gap: 20, flexWrap: "wrap" }}>
                                        <PollTypeSelect type="Image" val={"img"} selectedProp={mediaType === "img"} set={setMediaType} />
                                        <PollTypeSelect type="YouTube" val={"yt"} selectedProp={mediaType === "yt"} set={setMediaType} />
                                        <PollTypeSelect type="Spotify" val={"spot"} selectedProp={mediaType === "spot"} set={setMediaType} />
                                        <PollTypeSelect type="Soundcloud" val={"sc"} selectedProp={mediaType === "sc"} set={setMediaType} />
                                    </div>
                                </div>
                                <input value={mediaLink} onChange={(e) => setMediaLink(e.target.value)} className='input f1' type="text" placeholder='Optional media link' />
                            </div>
                            <div style={{ marginTop: 0, marginTop: 30, borderTop: "2px solid rgba(0,0,0,.1)" }}>
                                <div style={{ minHeight: 90 }}>
                                    <TagsCollection onClick={(index) => {
                                        const newTags = [...tags]
                                        newTags.splice(index, 1)
                                        setTags(newTags)
                                    }} tags={tags} />
                                </div>
                                <div className='flex aic' style={{ gap: 20, flexWrap: "wrap" }}>
                                    <input onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            addTag()
                                        }
                                    }} value={addTagInput} onChange={(e) => setAddTagInput(e.target.value)} className='input' type="text" placeholder='Search Tag' />
                                    <button className={`b3 ${tags.length > 4 || !addTagInput ? "disabled" : ""}`} style={{ height: 65 }} onClick={addTag}>+ Add</button>
                                </div>
                            </div>
                            <div className='flex fdc flexboxCreateSegment' style={{ paddingTop: 20, marginTop: 15, }}>
                                <div className='flex aic jcsb'>
                                    <CreateAspectTitle title="Poll Exipry Date" tip="Non pro user's polls will auto-expire after 7 days.">Expiry Date (optional)</CreateAspectTitle>
                                    <span style={{ fontWeight: "bold", cursor: "pointer", color: "#0074D9" }} onClick={() => setExpireDate("")}>Clear</span>
                                </div>
                                <input value={expireDate} onChange={(e) => setExpireDate(e.target.value)} onBlur={onExpireChange} className='input f1' type="date" placeholder='Optional media link' />
                                {!userData?.isPro
                                    ? <p style={{ color: "rgba(0,0,0,0.6)", fontWeight: 600, margin: 0, position: "relative", marginTop: 12, fontSize: 14 }}>Want polls to last for over 7 days? <span style={{ fontWeight: "bold", borderBottom: "2px solid #0074D9", cursor: "pointer", paddingBottom: 2, color: "#0074D9" }} onClick={() => navigate("/pro")}>Upgrade to PRO</span></p>
                                    : <p style={{ color: "rgba(0,0,0,0.6)", fontWeight: 600, margin: 0, position: "relative", marginTop: 12, fontSize: 14 }}>You are a <span style={{ fontWeight: "bold", cursor: "pointer", color: "#0074D9" }}>PRO</span> user, your poll will never expire unless an expiry date is set</p>
                                }
                            </div>
                            <div className="flexboxCreateSegment" style={{ paddingTop: 20, marginTop: 15, }}>
                                <InputHeader>Description</InputHeader>
                                <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                            </div>
                            {userData?.isPro
                                ? <div className="flexboxCreateSegment" style={{ paddingTop: 20, marginTop: 15, }}>
                                    <CreateAspectTitle title={"Private Poll"} tip={"Your poll will only be accessible to people with the direct link"}>Private Poll</CreateAspectTitle>
                                    <Switch checked={privatePoll} offColor="#e5e5e5" onColor='#0074D9' uncheckedIcon={null} checkedIcon={null} activeBoxShadow="none" onChange={(e) => setPrivatePoll(e)} />
                                </div>
                                : null
                            }
                            {userData?.isPro
                                ? <div className="flexboxCreateSegment" style={{ paddingTop: 20, marginTop: 15, }}>
                                    <CreateAspectTitle title={"Voter Count Limit"} tip={"Limit the amount of people who can vote on your poll"}>Voter Count Limit</CreateAspectTitle>
                                    <input value={voterCountLimit} onChange={(e) => {
                                        const numVal = parseInt(e.target.value)
                                        if (numVal < 1) {
                                            toast.error("Must be > 1")
                                        }
                                        setVoterCountLimit(numVal)
                                    }} type="number" min={1} className={`input ${!voterCountLimitActive ? "disabled" : ""}`} placeholder='Voter count limit' style={{ width: "100%", marginBottom: 20 }} />
                                    <Switch checked={voterCountLimitActive} offColor="#e5e5e5" onColor='#0074D9' uncheckedIcon={null} checkedIcon={null} activeBoxShadow="none" onChange={(e) => setVoterCountLimitActive(e)} />
                                </div>
                                : null
                            }
                            {userData?.isPro
                                ? <div className="flexboxCreateSegment" style={{ paddingTop: 20, marginTop: 15, }}>
                                    <CreateAspectTitle title={"CTA"} tip={"Link users to another page after voting"}>CTA (optional)</CreateAspectTitle>
                                    <input value={cta} onChange={(e) => setCTA(e.target.value)} type="text" className="input" placeholder='CTA Link' style={{ width: "100%", marginBottom: 20 }} />
                                </div>
                                : null
                            }
                            {userData?.isPro
                                ? <div className="flexboxCreateSegment" style={{ paddingTop: 0, marginTop: 15, }}>
                                    <CreateAspectTitle title={"Poll analytics"} tip="Users will be made aware when their data is being collected">Poll analytics</CreateAspectTitle>
                                    <p style={{ marginTop: 0, position: "relative", bottom: 6, fontWeight: "bold", opacity: .6 }}>Collect user analytics like location, device and OS</p>
                                    <Switch checked={pollAnalytics} offColor="#e5e5e5" onColor='#0074D9' uncheckedIcon={null} checkedIcon={null} activeBoxShadow="none" onChange={(e) => setPollAnalytics(e)} />
                                </div>
                                : null
                            }
                            <div style={{ marginTop: 30 }}>
                                <button onClick={onSubmit} className={`b3 ${!pollTitle || !pollType || (mediaLink && !mediaType) || ((pollType === "normal" || pollType === "rank") ? (!options[0] || !options[1]) : false) || tags.length < 1 || (!expireDate ? false : ((Date.now() > new Date(expireDate).getTime()) || (userData.isPro ? false : new Date(expireDate).getTime() > new Date(new Date().setDate(new Date().getDate() + 7)).getTime()))) || (userData?.isPro ? (!voterCountLimitActive ? false : !voterCountLimit) : false) ? "disabled" : ''}`}>Create Poll</button>
                            </div>
                        </div>
                    </div>
                </div>
            </PageContainer>
        </>
    )
}
